import { Button } from '@bpinternal/ui-kit-next'
import { ArrowLeft, X } from 'lucide-react'

type AddKnowledgeSourceHeaderProps = {
  close: () => void
  handleNavigateBack: () => void
  title: string
  hideBackArrow?: boolean
}

export const AddKnowledgeSourceHeader = ({
  close,
  handleNavigateBack,
  title,
  hideBackArrow,
}: AddKnowledgeSourceHeaderProps) => {
  return (
    <div className="m-6 mx-0 flex items-center justify-between text-foreground">
      <div className="flex items-center gap-2 text-lg font-bold">
        {!hideBackArrow && (
          <Button variant="ghost" onClick={handleNavigateBack} size="icon">
            <ArrowLeft />
          </Button>
        )}
        {title}
      </div>
      <Button className="text-foreground lg:hidden" onClick={close} variant="ghost" size="icon">
        <X size={16} />
        <span className="sr-only">Close</span>
      </Button>
    </div>
  )
}
